import { createUseStyles } from 'react-jss';

import { ITheme, mediaQuery } from '../../../styles';

export default createUseStyles(
  ({ breakpoints }: ITheme) => ({
    root: {
      backgroundColor: 'var(--x-bg-5)',

      [mediaQuery(breakpoints.tablet)]: {
        padding: '0',
      },
    },
    rootContainer: {
      maxWidth: 1360,
      padding: [56, 48],
      borderRadius: 32,
      margin: '0 auto',

      [mediaQuery(breakpoints.mobile)]: {
        padding: [40, 24],
      },
    },
    title: {
      color: 'var(--x-text-color-1)',
      fontStyle: 'normal',
      fontWeight: 500,
      fontSize: 42,
      lineHeight: '72px',
      textAlign: 'center',
      [mediaQuery(breakpoints.tablet)]: {
        fontSize: 30,
        lineHeight: '36px',
      },
    },
    description: {
      color: 'var(--x-text-color-2)',
      fontStyle: 'normal',
      fontWeight: '500 !important',
      fontSize: '16px !important',
      lineHeight: '24px',
      margin: '16px auto 40px auto',
      textAlign: 'center',
    },
    list: {
      display: 'grid',
      gap: 18,
      gridTemplateColumns: '1fr 1fr 1fr',
      marginBlockEnd: 40,

      [mediaQuery(breakpoints.laptop)]: {
        gridTemplateColumns: '1fr 1fr',
      },
      [mediaQuery(breakpoints.tablet)]: {
        gridTemplateColumns: '1fr',
      },
    },
    btnContainer: {
      textAlign: 'center',
    },
    button: {
      backgroundColor: 'var(--x-bg-7)',
      borderRadius: 24,
      padding: [12, 47],
      '&:hover': {
        backgroundColor: 'var(--x-bg-8)',
      },

      '&>span': {
        color: 'var(--x-black) !important',
        lineHeight: '24px',
      },
    },
    sameCategoryContainer: {
      display: 'grid',
      gap: 16,
      gridTemplateColumns: 'repeat(auto-fill, minmax(230px, 1fr))',
      listStyleType: 'none',
    },
    smallHeading: {
      color: 'var(--x-text-color-1)',
      marginBottom: 12,
      textAlign: 'center',
      fontSize: '20px !important',
      lineHeight: '28px',
    },
  }),
  { name: 'SingleToolSimilar' },
);
